/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleALeftIcon24Regular = forwardRef('ArrowShapeTriangleALeftIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.75 5.436c0-1.386-1.536-2.222-2.7-1.47L4.893 10.53a1.75 1.75 0 0 0 0 2.94l10.157 6.563c1.164.752 2.7-.084 2.7-1.47V5.436Zm-1.886-.21a.25.25 0 0 1 .386.21v13.127a.25.25 0 0 1-.386.21L5.707 12.21a.25.25 0 0 1 0-.42l10.157-6.564Z" })));
});
